export default "__VITE_ASSET__$qfVQzpy__"